
import PropTypes from "prop-types"
import React from "react"
import { Link, useStaticQuery } from "gatsby"



import "../css/basic-hero.css"

import Img from "gatsby-image"
const style = {
   
  }
  var height
  var position



  

class BasicHero extends React.Component{  




    constructor(props) {
        
        super(props);
      this.state={
          class:"basic-hero"
      }
     
      }

    


      componentDidMount () {
        this.timeoutId = setTimeout(function () {
            this.setState({ class: 'basic-hero mounted' });
        }.bind(this),1);
      } 
    
      componentWillUnmount () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
      }
 

  render() {
  

   
return(
   <div className={this.props.class? this.props.class + " " + this.state.class: this.state.class} >
<div>
<div>
    <h1>{this.props.title?this.props.title:'props.title'}</h1><p>{this.props.text?this.props.text:'props.text'}</p>
    
    </div></div>
<div>{this.props.image?this.props.image:'props.image'}</div>

   </div>)
  }
}
 
 

export default BasicHero


